<template>
  <div id="Hcp">
    <div class="Hcp-header" :class="{'de1':isDe,'es1':isEs,'po2':isPo||isDu||isFr}">
         <div class="menu-left" v-show="isHcp" :class="{'isM':!notM}">
           <div class="menu-item1" @click="back">
              <img src="../assets/Hcp-icon/menu/normal/Home.png">
              <p  v-show="notM">{{$t('pList')}}</p>
              <p  v-show="!notM">{{$t('connections')}}</p>
           </div>
         </div>
         <div class="menu-right" :class="{'personal':!isHcp,'es2':isEs}">
           <div class="menu-item3 menu-spe3" :class="{ 'item-choose':isG}" @click="changeMenu7" v-show="isHcp" >
             <img :src="portrait" class="portrait">
             <p>{{patientName}}</p>
           </div>
           <div class="menu-item3 per-item3" :class="{ 'item-choose':isA,'isM1':!notM}" @click="changeMenu1">
             <img src="../assets/Hcp-icon/menu/normal/chart setting.png" v-show="!isA">
             <img src="../assets/Hcp-icon/menu/highlight/chart setting_c.png" v-show="isA">
             <p>{{$t('settings')}}</p>
           </div>
           <div class="menu-item3 menu-spe2" :class="{ 'item-choose':isB,'isM1':!notM}" @click="changeMenu2">
             <img src="../assets/Hcp-icon/menu/highlight/monitor_c.png" v-show="isB">
             <img src="../assets/Hcp-icon/menu/normal/monitor.png" v-show="!isB">
             <p>{{$t('monitor')}}</p>
           </div>
           <div class="menu-item3"  :class="{ 'item-choose':isC,'isM2':!notM}" @click="changeMenu3">
             <img src="../assets/Hcp-icon/menu/highlight/Graphs_c.png" v-show="isC">
             <img src="../assets/Hcp-icon/menu/normal/graphs.png" v-show="!isC">
             <p>{{$t('graphs')}}</p>
           </div>
           <!--
           <div class="menu-item3"  :class="{ 'item-choose':isD}" @click="changeMenu4" v-show="notM">
             <img src="../assets/Hcp-icon/menu/highlight/events_c.png" v-show="isD">
             <img src="../assets/Hcp-icon/menu/normal/events.png" v-show="!isD">
             <p>{{$t('events')}}</p>
           </div>-->
           <div class="menu-item3"  :class="{ 'item-choose':isE}" @click="changeMenu5" v-show="notM">
             <img src="../assets/Hcp-icon/menu/highlight/records_c.png" v-show="isE">
             <img src="../assets/Hcp-icon/menu/normal/records.png" v-show="!isE">
             <p>{{$t('records')}}</p>
           </div>
           <div class="menu-item3"  :class="{ 'item-choose':isF}" @click="changeMenu6" v-show="no">
             <img src="../assets/Hcp-icon/menu/highlight/quick print_c.png" v-show="isF">
             <img src="../assets/Hcp-icon/menu/normal/quick print.png" v-show="!isF">
             <p>{{$t('qPrint')}}</p>
           </div>
         </div>
    </div>
    <div class="Hcp-container">
      <!-- <keep-alive> -->
       <router-view></router-view>
       <!-- </keep-alive> -->
    </div>
    <div class="Hcp-footer">
      <span>
<!--        <a href="http://www.medtrum.com/index.php/abouts">{{ $t('contact us') }} </a>-->
<!--          <a v-if="!isEU" href="http://www.medtrum.com/privacy_policy.html">|  {{ $t('Privacy Policy') }} </a>-->
<!--           <a v-if="!isEU" href="http://www.medtrum.com/terms_of_use.html">|  {{ $t('Terms of Use') }} | </a>-->
<!--           <a v-if="isEU" href="http://www.medtrum.co.uk/privacy_policy.html">|  {{ $t('Privacy Policy') }} </a>-->
<!--           <a v-if="isEU" href="http://www.medtrum.co.uk/terms_of_use.html">|  {{ $t('Terms of Use') }} | </a>-->

          <a :href="contactURL">{{ $t('contact us') }} </a>
          <a :href="privacyURL">|  {{ $t('Privacy Policy') }} </a>
          <a :href="termsOfUseURL">|  {{ $t('Terms of Use') }} | </a>

        {{$t('copyright')}}<br/>
          <a v-show="isZh" target=_blank href="http://beian.miit.gov.cn/"> 沪ICP备08013753号-3  </a>
          <img v-show="isZh" src="/static/beian.png" />
          <a v-show="isZh" target=_blank href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=31011502014155"> 沪公网安备 31011502014155号 </a>
      </span>
    </div>
  </div>
</template>

<script>
   import auth from '../auth/auth'
   export default{
     data(){
           return{
             isA:'', isB:'', isC:'',isD:'',isE:'', isF:'',isG:'',isHcp:true,notM:true,no:true,isDe:false,isEs:false,isDu:false,
             isPo:false,isFr:false,isZh:false,
             isEU:true,
             contactURL:'',
             privacyURL:'',
             termsOfUseURL:''
           }
       },
     computed:{
       portrait(){
           if(sessionStorage.getItem('patientId')){
             return '/api/v2.0/person/'+parseInt(sessionStorage.getItem('patientId'))+'/portrait'
           }else{
             return '/api/v2.0/person/'+parseInt(sessionStorage.getItem('uid'))+'/portrait'
           }
       },
       patientName(){
           return this.$store.state.patientName;
       },
       updateLocCode(){
         console.log('compute updateLocCode:');
         return this.$store.state.loc_code;
       }
     },
     watch:{
       updateLocCode(val){
         // this.$i18n.locale = val;
         console.log('watch updateLocCode:', val);
         let host=auth.getOuterHost();
         this.contactURL = host+'/contact.html';
         this.privacyURL = host+'/privacy_policy.html';
         this.termsOfUseURL = host + '/terms_of_use.html';
       }
     },
     mounted(){
       this.isA = (this.$route.path ==='/setting'||this.$route.path ==='/dateView2')?true:false;
       this.isB = (this.$route.path ==='/monitor')?true:false;
       this.isC = (this.$route.path ==='/chart1'||this.$route.path ==='/chart2'||this.$route.path ==='/chart3'||this.$route.path ==='/chart4'||this.$route.path ==='/chart5'||this.$route.path ==='/chart6')?true:false;
       this.isD = (this.$route.path ==='/events')?true:false;
       this.isE = (this.$route.path ==='/records')?true:false;
       this.isF = (this.$route.path ==='/print')?true:false;
       this.isG = (this.$route.path ==='/patientProfile'||this.$route.path ==='/patientProfile2')?true:false;
       this.isHcp =(sessionStorage.getItem('userType')==='P')?false:true;
       this.notM = (sessionStorage.getItem('userType')==='M')?false:true;

       let lang = sessionStorage.getItem('language');
       this.isDe= (lang==='de')?true:false;
       this.isEs= (lang==='es')?true:false;
       this.isPo= (lang==='po')?true:false;
       this.isDu= (lang==='du')?true:false;
       this.isFr= (lang==='fr')?true:false;
       this.isZh = (lang==='zh')?true:false;
       if(sessionStorage.getItem('userType')!=='P'){
         let Pid = parseInt(sessionStorage.getItem('patientId'));
         //auth.getPortrait(this,Pid);
        let patientName = sessionStorage.getItem('patientName');
         this.$store.commit('updatePatientName',patientName);
       }

       if(sessionStorage.getItem('userType')!=='P'){
         this.uid = parseInt(sessionStorage.getItem('patientId'));
       }else{
         this.uid = parseInt(sessionStorage.getItem('uid'));
       }

       let countryIndex=localStorage.getItem('index');
       //console.info('countryIndex:'+countryIndex);
       if (1==countryIndex || 6==countryIndex || 14==countryIndex) {
         this.isEU=false;
       }
       setTimeout(()=>{
         let host=auth.getOuterHost();
         this.contactURL = host+'/contact.html';
         this.privacyURL = host+'/privacy_policy.html';
         this.termsOfUseURL = host + '/terms_of_use.html';
       }, 50)
     },
     methods:{
       changeMenu1(){
         this.isA = true;
         this.isB = false;
         this.isC = false;
         this.isD = false;
         this.isE = false;
         this.isF = false;
         this.isG = false;
         if(this.$route.path ==='/setting'||this.$route.path ==='/dateView2'){
           this.$router.push(this.$route.path);
         }else{
           if(sessionStorage.getItem('userType')==='M'){
             this.$router.push('/setting');
           }else{
             this.$router.push('/dateView2');
           }
         }
       },
       changeMenu2(){
         this.isB = true;
         this.isA = false;
         this.isC = false;
         this.isD = false;
         this.isE = false;
         this.isF = false;
         this.isG = false;
         this.$router.push('/monitor');
       },
       changeMenu3(){
         this.isC = true;
         this.isA = false;
         this.isB = false;
         this.isD = false;
         this.isE = false;
         this.isF = false;
         this.isG = false;
         console.log("hcp.vue:"+this.$route.path);
         let that=this;

         // if(this.$route.path ==='/chart1'||this.$route.path ==='/chart2'||this.$route.path ==='/chart3'||this.$route.path ==='/chart4'||this.$route.path ==='/chart5'||this.$route.path ==='/chart6'){
         //   this.$router.push(this.$route.path);
         // }else{
         //   this.$router.push('/chart1');
         // }
         auth.getDataMap(this, this.uid, function(res){
           if (0!=res.error) {
             return;
           }
           //console.log('getDataMap:', res)
           var chart_end_time=(res.end.cgms > res.end.pump)?res.end.cgms:res.end.pump;
           sessionStorage.setItem('chart_end_time', chart_end_time);

           if(that.$route.path ==='/chart1'||that.$route.path ==='/chart2'||that.$route.path ==='/chart3'||
              that.$route.path ==='/chart4'||that.$route.path ==='/chart5'||that.$route.path ==='/chart6'){
             that.$router.push(that.$route.path);
           }else{
             that.$router.push('/chart0');
           }
         })

       },
       changeMenu4(){
         this.isD = true;
         this.isA = false;
         this.isB = false;
         this.isC = false;
         this.isE = false;
         this.isF = false;
         this.isG = false;
         this.$router.push('/events');
       },
       changeMenu5(){
         this.isE = true;
         this.isA = false;
         this.isB = false;
         this.isC = false;
         this.isD = false;
         this.isF = false;
         this.isG = false;
         this.$router.push('/records');
       },
       changeMenu6(){
         this.isF = true;
         this.isA = false;
         this.isB = false;
         this.isC = false;
         this.isD = false;
         this.isE = false;
         this.isG = false;
         this.$router.push('/print');
       },
       changeMenu7(){
         this.isG = true;
         this.isA = false;
         this.isB = false;
         this.isC = false;
         this.isD = false;
         this.isE = false;
         this.isF = false;
         let Pid = parseInt(sessionStorage.getItem('patientId'));
         if(sessionStorage.getItem('userType')==='D'){
           auth.goPatientProfile(this,Pid);
         }else{
           this.$router.push('/patientProfile3');
         }
       },
       back(){
         sessionStorage.removeItem('rid');
         sessionStorage.removeItem('dateViewA');
         auth.clearSession();
         if(this.notM){
           this.$router.push('/PatientList');
         }else{
           this.$router.push('/carerConnection');
         }
       },
     },
   }
</script>

<style scoped>
  #Hcp{
    min-height:889px;
    width:100%;
    background-color:#fff;
  }
  .Hcp-header{
    width:100%;
    height: 85px;
    background:#ecf7ff;
  }
  .menu-left{
    float: left;
    width: 30%;
    height: 85px;
    font-family:SFUIText-Regular;
    font-size:14px;
    letter-spacing:-0.34px;
    text-align:center;
  }
  .menu-item1{
    float:right;
    margin-top:15px;
    cursor: pointer;
    margin-right: 10%;
  }
  .menu-item1 p{
    margin-top: 10px;
  }
  .menu-item2{
    float: right;
    cursor: pointer;
    margin:15px 10% 0 7%;
    width:60px;
  }
  .menu-item2 p{
    margin-top: 7px;
  }
  .menu-right{
    float: left;
    width:65%;
    height: 85px;
    background-image:linear-gradient(90deg,#d7edff 0%, #ecf7ff 100%);
    font-family:SFUIText-Regular;
    font-size:14px;
    color:#282828;
    text-align:center;
  }
  .menu-item3{
    float: left;
    margin-top: 23px;
    margin-left: 6%;
    cursor: pointer;
  }
  .menu-item3  p{
    margin-top: 4px;
  }
  .item-choose{
    color:#005dac;
  }
  .menu-spe2{
    margin-top: 19px;
  }
  .menu-spe3{
    margin-top: 16px;
  }
  .personal{
    width: 80%;
    float: none;
    margin:0 auto ;
    background:#ecf7ff;
  }
  .personal .menu-item3{
    margin-left: 7%;
  }
  .personal .per-item3{
    margin-left: 22%;
  }
  .portrait{
    border-radius:100px;
    width:30px;
    height:30px;
  }
  .isM1{
    margin-left: 9%;
  }
  .isM2{
    margin-left: 9%;
    margin-right: 2%;
  }

  .Hcp-container{
    width:62%;
    margin:0 auto;
    background:#fafbfc;
  }

  .Hcp-footer{
    font-family:HelveticaNeue;
    font-size:14px;
    color:rgba(120,120,120,0.90);
    letter-spacing:-0.34px;
    text-align:center;
    margin-top: 13px;
    *margin-bottom: 10px;
  }
  .Hcp-footer a{
    color:rgba(120,120,120,0.90);
    text-decoration: none;
  }
  .Hcp-footer a:hover{
    color:#0090D3;
  }
  .de1 .menu-left{
    width: 28%;
  }
  .es1 .menu-left{
    width: 29%;
  }
  .es1 .menu-item3{
    margin-left: 5%;
  }
  .es1 .personal .per-item3{
    margin-left: 22%;
  }

  .po2 .menu-left{
    width: 29%;
  }
  .po2 .menu-item3{
    margin-left: 5%;
  }
  .po2 .personal .per-item3{
    margin-left: 22%;
  }
  @media screen and (max-width: 1500px){
    .Hcp-container{
      width:92%;
    }
    .menu-left{
      width: 24%;
    }
    .menu-right{
      width: 72%;
    }
    .isM1{
      margin-left: 10%;
    }
    .isM2{
      margin-left: 10%;
      margin-right: 2%;
    }
    .personal{
      width: 90%;
    }
    .personal .menu-item3{
      margin-left: 8%;
    }
    .personal .per-item3{
      margin-left: 14%;
    }
    .de1 .menu-left{
      width: 19%;
    }
    .es1 .menu-left{
      width: 20%;
    }
    .es1 .menu-item3{
      margin-left: 5.5%;
    }
    .es1 .personal .per-item3{
      margin-left: 12%;
    }
    .po2 .menu-left{
      width: 20%;
    }
    .po2 .menu-item3{
      margin-left: 6%;
    }
    .po2 .personal .per-item3{
      margin-left: 12%;
    }
  }
</style>



// WEBPACK FOOTER //
// HCP.vue?3c9efb0c